import React, { useEffect, useState } from "react";
import { Button, Container, Col, Form, Nav, Row, Image, Spinner ,Modal } from "react-bootstrap";
import { useNavigate, NavLink } from "react-router-dom";
import trash from "../../../assets/images/icons/trash.svg";
import edit from "../../../assets/images/icons/edit.svg"
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  coachAddCertificate,
  coachDeleteCertificate
} from "../../../utils/api";
import { useUserContext } from "../../../utils/hooks/UserContext";
import { toast } from "react-toastify";
import Loader from "../../../Loader/Loader";
import moment from 'moment'
const initialValuesCerti = {
  name: "",
  organization: "",
};

const certificateSchema = Yup.object().shape({
  name: Yup.string().required("Name is required").max(50),
  organization: Yup.string()
    .required("Issuing Organization is required")
    .max(100),
});

const EditProfileCertificates = (props) => {
    const [certificates, setcertificates] = useState([]);
    const navigate = useNavigate();
    const { getUserFromToken, user } = useUserContext();
    const [visible, setVisible] = useState(false);
    const [deleteId, setDeleteId] = useState("");
    const [certiVisible, setCertiVisible] = useState(false);
    const [isSave, setSaved] = useState(false);
    
    useEffect(() => {
      const canonicalUrl = `${window.location.origin}${window.location.pathname}`;
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonicalUrl);
  
      setcertificates(user?.certificates);
    }, [user]);
  
  
    //////////////////////////// Start Certificate /////////////////////////////
    const handleSubmitCertificate = (values, { resetForm }) => {
      formikCerti.setValues({
        ...formikCerti.values,
        name: "",
        organization: ""
      });
  
      setcertificates([
        ...certificates,
        {
          id: new Date()?.getTime(),
          name: values?.name,
          organization: values?.organization,
          status: "new",
        },
      ]);
      setSaved(true)
      resetForm();
    };

  
    // Handle Update API Call
    const formikCerti = useFormik({
      initialValues: initialValuesCerti,
      validationSchema: certificateSchema,
      onSubmit: handleSubmitCertificate,
    });
    //////////////////////////// End Certificate /////////////////////////////
    const onRemoveCertificate = (id) => {
      const results = JSON.parse(JSON.stringify(certificates))?.map((i) => {
        if (id === i?.id) {
          i.status = "deleted";
        }
        return i;
      });
      setcertificates(results);
      setCertiVisible(false);
      setVisible(false);
    };
    const handleDelete = (id, delete_type) => {
     if (delete_type === "certificate") {
        setDeleteId(id);
        setCertiVisible(true);
        setVisible(true);
        onRemoveCertificate(id)
      }
    };


    
      const onClickSave = async (values) => {
        try {
    
          let test = false;
          // handle certificate
          const newCertificate = certificates?.filter((i) => i?.status === "new");
          for (let index = 0; index < newCertificate?.length; index++) {
            const element = newCertificate[index];
            const formData = new FormData();
            formData.append("name", element?.name);
    
            formData.append("organization", element?.organization);
    
           let data =  await coachAddCertificate(formData);
          test = data.data?.status;

          }
    
          const deletedCertificate = certificates?.filter(
            (i) => i?.status === "deleted"
          );
    
          if (deletedCertificate?.length > 0) {
            const formData = new FormData();
            formData.append(
              "certificate_ids",
              `[${deletedCertificate?.map((i) => i?.id)}]`
            );
    
            let data =await coachDeleteCertificate(formData);
            test = data.data?.status;
          }
          if(test){
            setSaved(false)
            toast.success("Certificate updated successfully.")
          }
        } catch (error) {
          toast.error(error?.response?.data?.message || error?.message);
        } finally {
          getUserFromToken();
          navigate("/coach/profile");
        }
      };
  return (
    <>
    <Modal size="lg" {...props} aria-labelledby="contained-modal-title-vcenter" centered>
      <div className="profile_edit_forms my_light_modal">

          <Container>
            <Row className='g-3'>
              <Col lg="12">
                <Form className="px-3 py-2" onSubmit={formikCerti.handleSubmit} >
                  <Col sm="12" className="mb-4">
                    <Form.Label className="title">Certificates</Form.Label>
                    <>
                      {certificates
                        ?.filter((i) => i?.status !== "deleted")
                        ?.map((certificate) => (
                          <Row>
                            <Col className="col-12 mx-auto">
                              <div className="pr_dtls_prvw">
                                <div>
                                  <p className="fs-16 fw-500 text_brand_color4 m-0">
                                    <u>{certificate.name}</u>
                                  </p>
                                  <small className="d-block fs-12 fw-400 text_brand_color4">
                                    {certificate.organization}
                                  </small>
                                </div>
                                <div className="d-flex align-items-center">
                                  {/* <Button className="p-0 m-2" variant="" 
                                  onClick={() => handleCerEdit(certificate)}>
                                    <Image height={27} src={edit} />
                                  </Button> */}
                                  <Button className="p-0 m-2"
                                    variant=""
                                    onClick={() =>
                                      handleDelete(certificate?.id, "certificate")
                                      } >
                                    <Image src={trash} />
                                  </Button>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        ))}
                      <Row>
                        <Col
                          className={
                            window.innerWidth < 500 ? "col-auto mt-3 w-100" : ""
                          }
                        >
                          <Form.Group as={Col} className="" controlId="">
                            <Form.Control
                              type="text"
                              placeholder="Name"
                              name={`name`}
                              value={formikCerti.values.name}
                              onChange={formikCerti.handleChange}
                              isInvalid={
                                formikCerti?.touched?.name &&
                                !!formikCerti?.errors?.name
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              {formikCerti?.errors?.name &&
                                formikCerti?.touched?.name && (
                                  <div>{formikCerti?.errors?.name}</div>
                                )}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col
                          className={
                            window.innerWidth < 500
                              ? "col-auto mt-3 w-100 mb-2"
                              : ""
                          }
                        >
                          <Form.Group as={Col} className="" controlId="">
                            <Form.Control
                              type="text"
                              placeholder="Issuing Organization"
                              name={`organization`}
                              value={formikCerti.values.organization}
                              onChange={formikCerti.handleChange}
                              isInvalid={
                                formikCerti?.touched?.organization &&
                                !!formikCerti?.errors?.organization
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              {formikCerti?.errors?.organization &&
                                formikCerti?.touched?.organization && (
                                  <div>{formikCerti?.errors?.organization}</div>
                                )}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col className="mb-3 col-auto">
                          <Button
                            variant="success"
                            type="submit"
                            className="px-4"
                            style={{
                              marginLeft: window.innerWidth < 500 && "250px",
                            }}
                            disabled={!formikCerti.values.name || !formikCerti.values.organization}
                          >
                            Add
                          </Button>
                        </Col>
                      </Row>
                    </>
                  </Col>
                </Form>
              </Col>
            </Row>
            <Row className='justify-content-end mt-4'>
              <Col sm="auto">
                  <Button variant='success' className='px-5' disabled={!isSave} onClick={isSave ? onClickSave : undefined}>Save</Button>
              </Col>
            </Row>
          </Container>

      </div>
    </Modal>
    </>
  );
}

export default EditProfileCertificates;